export default "__VITE_ASSET__Dr6CnBHU__"